import { useRoute } from 'vue-router'
/**
 * 各頁面標題及選單圖示定義
 * 自行新增的 icon 在 unocss.config.ts 定義後才可在其他頁面使用 https://icon-sets.iconify.design/
 */
const routeMeta = {
  // '/admin/dashboard': {
  //   title: '儀表板',
  //   icon: 'i-ep-menu',
  //   idleTimeout: 0, // 秒
  // },
}
/** 取得各頁面資訊對應表 */
export function useRouteMeta() {
  return routeMeta
}
/** 取得標題 */
export function useRouteMetaTitle() {
  const route = useRoute()
  if (routeMeta[route.path] && routeMeta[route.path].title) {
    return routeMeta[route.path].title
  }
  else {
    throw new Error('標題未定義')
  }
}

export function useRouteMetaBreadcrumb(path) {
  if (routeMeta[path]) {
    const routeItem = {
      path,
      meta: routeMeta[path],
    }
    const parentPath = path.replace(/\/[^/]+$/, '')
    if (parentPath.length > 0 && parentPath.length !== path.length) {
      return [
        ...useRouteMetaBreadcrumb(parentPath),
        routeItem,
      ]
    }
    else {
      return [routeItem]
    }
  }
  else {
    return []
  }
}
